export const langText: any = {
    jp: {
        link_coming: 'もうすぐ発売',
        link_more: '詳しくはこちら',
        link_buy: '今すぐ購入',
        link_cart: 'カートに入れる',
        price_prefix: '',
        price_suffix: '（税込）',
        off: 'OFF',
        times: '倍',
        point: 'ポイント',
    },
};
